import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propBool, propFunc, propOneOf, propShape, propStr, } from '../../../../helpers/custom-prop-types';
import SlideSearchRegistrationForm from '../../../Ui/SlideSearch/Form/SlideSearchRegistrationForm';
import SlideSearchRegistrationCompleteModal from '../../../Ui/SlideSearch/Modal/SlideSearchRegistrationCompleteModal';
import SlideSearchRegistrationModal from '../../../Ui/SlideSearch/Modal/SlideSearchRegistrationModal';
import SlideSearchPaidRecommendModal from './SlideSearchPaidRecommendModal';
const SlideSearchRegistrationModals = (props) => {
    const { canRegistrationTrial, email, hideCompleteModal, hideFormModal, hidePaidModal, initialValues, isShowCompleteModal, isShowFormModal, isShowPaidModal, kanaRef, onSubmitRegistration, userMode, } = props;
    return (_jsxs(_Fragment, { children: [_jsx(SlideSearchRegistrationModal, { formComponent: _jsx(SlideSearchRegistrationForm, { canRegistrationTrial: canRegistrationTrial, kanaRef: kanaRef, userMode: userMode }), hideModal: hideFormModal, initialValues: initialValues, isShow: isShowFormModal, onSubmit: onSubmitRegistration }), _jsx(SlideSearchRegistrationCompleteModal, { email: email, hideModal: hideCompleteModal, isShow: isShowCompleteModal }), _jsx(SlideSearchPaidRecommendModal, { hideModal: hidePaidModal, isShow: isShowPaidModal })] }));
};
SlideSearchRegistrationModals.propTypes = {
    canRegistrationTrial: propBool().isRequired,
    email: propStr().isRequired,
    hideCompleteModal: propFunc().isRequired,
    hideFormModal: propFunc().isRequired,
    hidePaidModal: propFunc().isRequired,
    initialValues: propShape().isRequired,
    isShowCompleteModal: propBool().isRequired,
    isShowFormModal: propBool().isRequired,
    isShowPaidModal: propBool().isRequired,
    kanaRef: propShape().isRequired,
    onSubmitRegistration: propFunc().isRequired,
    userMode: propOneOf(['guest', 'client', 'free_professional', 'professional'])
        .isRequired,
};
export default SlideSearchRegistrationModals;
